var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrLinkedIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4483 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29102 8.75V9.25H9.37435V8.75H7.29102ZM7.08268 8C6.85256 8 6.66602 8.22386 6.66602 8.5V9.5C6.66602 9.77614 6.85256 10 7.08268 10H9.58268C9.8128 10 9.99935 9.77614 9.99935 9.5V8.5C9.99935 8.22386 9.8128 8 9.58268 8H7.08268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4482 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 8.75V9.25H2.70833V8.75H0.625ZM0.416667 8C0.186548 8 0 8.22386 0 8.5L0 9.5C0 9.77614 0.186548 10 0.416667 10H2.91667C3.14679 10 3.33333 9.77614 3.33333 9.5V8.5C3.33333 8.22386 3.14679 8 2.91667 8H0.416667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4481 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95801 0.75V1.25L6.04134 1.25V0.75L3.95801 0.75ZM3.74967 0C3.51956 0 3.33301 0.223858 3.33301 0.5V1.5C3.33301 1.77614 3.51956 2 3.74967 2L6.24967 2C6.47979 2 6.66634 1.77614 6.66634 1.5V0.5C6.66634 0.223858 6.47979 0 6.24967 0L3.74967 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.625C5.17259 1.625 5.3125 1.79289 5.3125 2V4.5C5.3125 4.70711 5.17259 4.875 5 4.875C4.82741 4.875 4.6875 4.70711 4.6875 4.5V2C4.6875 1.79289 4.82741 1.625 5 1.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24246 4.60983C8.53006 4.95496 8.64648 5.4422 8.64648 6V8C8.64648 8.20711 8.50657 8.375 8.33398 8.375C8.1614 8.375 8.02148 8.20711 8.02148 8V6C8.02148 5.5578 7.92957 5.29504 7.80051 5.14017C7.67146 4.98529 7.45248 4.875 7.08398 4.875H2.91732C2.54882 4.875 2.32985 4.98529 2.20079 5.14017C2.07173 5.29504 1.97982 5.5578 1.97982 6V8C1.97982 8.20711 1.83991 8.375 1.66732 8.375C1.49473 8.375 1.35482 8.20711 1.35482 8V6C1.35482 5.4422 1.47124 4.95496 1.75885 4.60983C2.04645 4.26471 2.45248 4.125 2.91732 4.125H7.08398C7.54882 4.125 7.95485 4.26471 8.24246 4.60983Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrLinkedIndicator);
export default __webpack_public_path__ + "static/media/sr-linked-indicator.15807cc360d92f6dc6449d7582b01a07.svg";
export { ForwardRef as ReactComponent };